import { render, staticRenderFns } from "./AIModelLayerComponent.vue?vue&type=template&id=dbdf8460&"
import script from "./AIModelLayerComponent.vue?vue&type=script&lang=js&"
export * from "./AIModelLayerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports